import { GatekeeperClient } from "./client";

/**
 * add new flags here
 */
const flags = new Map<string, boolean>([
  ["dotcom_dynamic_yield", true],
  ["dotcom_cblogger_captureClick", true],
  ["dotcom_cblogger_captureError", true],
  ["dotcom_cblogger_enableConsoleLogs", true],
]);

const Gatekeeper = () => <GatekeeperClient />;

const resolveCallComplete: { current?: () => void } = {};

Gatekeeper.ready = new Promise<void>((resolve) => {
  resolveCallComplete.current = resolve;
});

const buildFullUrl = (userId: string) => {
  const flagKeys = flags.keys();
  const parameters = new URLSearchParams({
    flags: [...flagKeys].join(","),
    userId,
  });
  return `/api/gatekeeper?${parameters.toString()}`;
};

const fetchFlags = async (userId: string) => {
  const response = await fetch(buildFullUrl(userId), {
    cache: "no-store",
  });
  const result: { flags: Record<string, boolean> } =
    (await response.json()) as { flags: Record<string, boolean> };
  return result.flags;
};

Gatekeeper.init = async () => {
  const SESSION_STORAGE_ID = "userGatekeeperId";

  let userId = sessionStorage.getItem(SESSION_STORAGE_ID) ?? "0";
  if (userId !== "0") {
    // eslint-disable-next-line sonarjs/pseudo-random -- this is the psuedorandom that gatekeeper uses
    userId = JSON.stringify(Math.floor(Math.random() * 100 + 1));
    sessionStorage.setItem(SESSION_STORAGE_ID, userId);
  }
  try {
    const gkFlags = await fetchFlags(userId);

    for (const [key, value] of Object.entries(gkFlags)) {
      setFlag(key, value);
    }
    enforceQueryParameters();
  } catch (error) {
    console.error(error);
  }
};

Gatekeeper.isWindow = (): boolean => typeof window !== "undefined";
Gatekeeper.getAllFlags = () => Object.fromEntries(flags);

Gatekeeper.getUrlParameters = () => {
  if (!Gatekeeper.isWindow()) {
    return new URLSearchParams();
  }
  // eslint-disable-next-line unicorn/prefer-global-this -- disable to get version bump through
  return new URLSearchParams(window.location.search);
};

const setFlag = (name: string, value = true): Map<string, boolean> =>
  flags.set(name, value);

Gatekeeper.getFlag = async (name: string) => {
  await Gatekeeper.ready;
  return flags.get(name) ?? false;
};

const enforceQueryParameters = () => {
  const urlParameters = Gatekeeper.getUrlParameters();
  const enableFlagsString = urlParameters.get("enableFlags");
  const enableFlags = enableFlagsString ? enableFlagsString.split(",") : [];
  const disableFlagsString = urlParameters.get("disableFlags");
  const disableFlags = disableFlagsString ? disableFlagsString.split(",") : [];
  for (const flagName of enableFlags) {
    setFlag(flagName, true);
  }
  for (const flagName of disableFlags) {
    setFlag(flagName, false);
  }
  resolveCallComplete.current?.();
  console.log("Gatekeeper Complete", Gatekeeper.getAllFlags());
};

export default Gatekeeper;
